export function asyncSleep(sleepTime = 0): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, sleepTime));
}
